// extracted by mini-css-extract-plugin
module.exports = {"Container":"Checkbox_Container__hBYcX","Input":"Checkbox_Input__qX_3q","Label":"Checkbox_Label__xnBGD"};